import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MainLayout from 'src/components/MainLayout';
import 'src/lib/translation/i18n';
import { AuthProvider } from 'src/provider/AuthProvider';

function App() {
  // const { i18n } = useTranslation(['main'])
  // const currentLang = i18n.language

  // useEffect(() => {
  //   let pName = window.location.pathname + window.location?.search
  //   console.log('🚀 ~ file: useDetectLang.ts ~ line 15 ~ useEffect ~ detectedLng', currentLang, pName)
  //   if (!i18nextConfig.i18n.locales.includes(pName.split('/')[1])) {
  //     window.location.replace(`/${currentLang}${pName}`)
  //   }
  // }, [])

  return (
    <AuthProvider>
      <RouterProvider router={MainLayout} />
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={true}
        theme="colored"
        limit={3}
      />
    </AuthProvider>
  );
}

export default App;
